import Joi from '@hapi/joi'

export const DailyAttendanceSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
        
    }),
    estate: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate required`,
    }),
    date: Joi.string().invalid("").label("Date").messages({
        "any.invalid": `Date required`,
    })
}